﻿import React from 'react'
import { Text } from '../ui'
import type { DiarioRelatorioRow } from '../../types/comercialContatosPortal'

function formatarDataHoraDiario(iso: string): string {
  try {
    return new Date(iso).toLocaleString('pt-BR', {
      dateStyle: 'short',
      timeStyle: 'short',
    })
  } catch {
    return iso
  }
}

type HistoricoDiarioTableProps = {
  rows: DiarioRelatorioRow[]
}

const HistoricoDiarioTable: React.FC<HistoricoDiarioTableProps> = ({ rows }) => {
  return (
    <table className="w-full divide-y divide-gray-200 dark:divide-gray-700">
      <thead className="bg-gray-50 dark:bg-gray-700 sticky top-0 z-10">
        <tr>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider sticky left-0 z-20 bg-gray-50 dark:bg-gray-700">
            Comercial responsável
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
            Consultor responsável
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
            Corretor
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
            Responsável
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
            Data e Horário
          </th>
          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
            Diário
          </th>
        </tr>
      </thead>
      <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
        {rows.map(row => (
          <tr key={row.id} className="hover:bg-gray-50 dark:hover:bg-gray-700">
            <td className="px-4 py-4 text-left align-top sticky left-0 z-10 bg-gray-50 dark:bg-gray-700">
              <Text size="sm" className="text-gray-900 dark:text-white font-medium">
                {row.comercial_responsavel_nome || '—'}
              </Text>
            </td>
            <td className="px-4 py-4 text-left align-top">
              <Text size="sm" className="text-gray-900 dark:text-white font-medium">
                {row.consultant_responsavel_nome || '—'}
              </Text>
            </td>
            <td className="px-4 py-4 text-left align-top">
              <Text size="sm" className="text-gray-900 dark:text-white font-medium">
                {row.corretora_nome}
              </Text>
            </td>
            <td className="px-4 py-4 text-left align-top">
              <Text size="sm" className="text-gray-900 dark:text-white font-medium">
                {row.responsavel_nome}
              </Text>
            </td>
            <td className="px-4 py-4 text-left align-top whitespace-nowrap">
              <Text size="sm" className="text-gray-500 dark:text-gray-400">
                {formatarDataHoraDiario(row.created_at)}
              </Text>
            </td>
            <td className="px-4 py-4 text-left align-top">
              <Text size="sm" className="text-gray-700 dark:text-gray-300 whitespace-pre-wrap">
                {row.body}
              </Text>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default HistoricoDiarioTable
